<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4>Companies</h4>
            <button @click="newCompany"
                    class="btn btn-primary"
                    :disabled="loading">
                New company
            </button>
        </div>
        <AppTable :columns="columns"
                  :query="query"
                  :rows="companies"
                  @on-row-click="viewCompany"
                  :loading="loading"
                  :total="total"
                  mode="remote"
                  @on-query-change="onQueryChange">
            <template slot="table-row" slot-scope="props">
                <!-- Types -->
                <span v-if="props.column.field === 'types'">
                  <span v-if="props.row.types">
                      <span v-for="type in props.row.types" :key="type.id"
                            class="text-secondary">
                           {{ type.name }}
                      </span>
                  </span>
                </span>
                <!-- Other -->
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
            </template>
        </AppTable>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppTable from '../form/AppTable';

export default {
  components: {
    AppTable,
  },
  computed: {
    ...mapGetters({
      companies: 'companies/companies',
    }),
    ...mapState({
      query: (state) => state.companies.query,
      total: (state) => state.companies.totalCompanies,
    }),
    columns() {
      return [
        {
          label: 'Name',
          field: 'name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Invoice email',
          field: 'email',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Country',
          field: 'location.country.name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Types',
          field: 'types',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.getCompanies();
  },
  methods: {
    newCompany() {
      this.$router.push({
        name: 'company',
        params: { id: 'new' },
      });
    },
    getCompanies() {
      this.loading = true;

      this.$store.dispatch('companies/getCompanies')
        .finally(() => {
          this.loading = false;
        });
    },
    viewCompany(event) {
      this.$router.push({
        name: 'company',
        params: { id: event.row.id },
      });
    },

    onQueryChange(props) {
      this.$store.commit('companies/queryProps', props);
      this.getCompanies();
    },
  },
};
</script>
